import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppButton } from '../ui/WhatsAppButton';
export function Layout() {
  return <div className="flex flex-col min-h-screen bg-[#F4E8D0]/30" data-id="element-116">
      <Navbar data-id="element-117" />
      <main className="flex-grow" data-id="element-118">
        <Outlet data-id="element-119" />
      </main>
      <Footer data-id="element-120" />
      <WhatsAppButton data-id="element-121" />
    </div>;
}